<template>
<div id="Recycle-pop" class="My_popup">
  <div class="My_popup_wrap">
	<span class="My_popup_close" href="#" @click.prevent="closeClickHandler" style="cursor: pointer;">닫기</span>
	<div class="My-popup-title">은평구 광역자원 순환센터</div>
	<div class="My-popup-content green-line">
		<div class="recycle-detail01">
			<p>재활용 선별시설을 품은 <strong>생활형 SOC복합센터,</strong></p>
			<p><b>힘찬 날갯짓이 시작됩니다.</b></p>
			<p class="mt-20"><img src="@/assets/images/visual03.png" alt="서북3구"></p>
			<dl class="recycle-txt">
				<dt>서북 3구 공동 이용협력체계 구축합니다.</dt>
				<dd>각 구에 있는 시설을 공동 이용하는 <b>협력체계를 구축</b>하게 됩니다.</dd>
				<dd>자체시설을 공동이용함으로써 재정부담을 덜고 <b>안정적이고 효율적인 폐기물 처리가 가능</b>해집니다.</dd>
				<dd>마포 - 생활폐기물, 서대문 - 음식물쓰레기,은평구 - 재활용품 처리를 맡습니다.</dd>
			</dl>

			<dl class="recycle-txt">
				<dt>쓰레기대란을 막는 유일한 방안입니다.</dt>
				<!-- <dd>현재 이용중인 수도권매립지는 7년후 이용이 불확실하며 <br>양주소각장은 <b>생활폐기물 반입이 불가하다는 통보</b>를 받았습니다.</dd>
				<dd>은평구 폐기물 일일 발생량 263통중 <b>자체처리는 불과 37%</b></dd>
				<dd>고양시 도내동 은평구 폐기물 적환장 이전 요구 <br>(2019년 6월 이후 이행강제금 연 23억 부과 및 고발예정)</dd> -->
				<dd>현재 이용중인 수도권매립지는  <b>2025년 이후 이용이 불확실</b>합니다.</dd>
				<dd>은평구 폐기물 일일 발생량 286톤중 <b>자체처리는 불과 37.6%</b></dd>
			</dl>

			<dl class="recycle-txt">
				<dt>기존시설 노후로 대체시설 필요합니다.</dt>
				<dd>2001년 2월부터 운영한 노후시설로 시설규모(30톤/일)에 비해 <b>20톤이상 초과 처리</b>하고 있습니다.</dd>
				<dd>초과처리로 인해 효율이 저하되고 작업공간이 협소하여 화재 등 <b>안전사고에 취약</b>합니다.</dd>
			</dl>

			<dl class="recycle-txt">
				<dt>주민을 위한 시설로 만들겠습니다.</dt>
				<dd>폐기물처리시설은 <b>지하에 건립되어</b> 지상에 노출되지 않습니다.</dd>
				<dd>재활용선별시설(150톤/일, 광역시설), 생활폐기물 압축·적환시설(130톤/일, 단독시설), <br>대형폐기물적환시설(25톤/일, 단독시설)</dd>
				<dd>지상에는 축구장, 다목적구장 등 <b>주민 누구나 이용 가능한 종합체육시설</b>이 만들어집니다.</dd>
				<!-- <dd><b>완전 지하</b>에 건립되며 지상에 노출되지 않습니다.</dd>
				<dd>재활용품 선별시설(150톤/일), 생활페기물</dd>
				<dd>지상공간에는축구장, 배드민턴장, 족구장등 <br><b>주민누구나 이용 가능한 종합체육시설</b>이 생깁니다.</dd> -->
			</dl>

			<dl class="recycle-txt">
				<dt>환경문제 걱정 없도록 하겠습니다.</dt>
				<dd>물리적인 재활용품 선별시설로서 환경에 영향을 주는 <b>소각이나 음식물처리 시설이 아닙니다.</b></dd>
				<dd>악취, 침출수 발생요인이 적으며 <b>최신설비로 차단 및 정화</b>하겠습니다.</dd>
				<dd>지하에 건립되어 소음확산을 방지 할 것입니다.</dd>
			</dl>

			<dl class="recycle-txt">
				<dt>교통영향 최소화하겠습니다.</dt>
				<dd>시설 건립시 수거차량은 약 90대로 <b>교통량 최소시간대 <br>(0시~6시)에 집중운행</b>하여 교통영향이 미미할 것입니다.</dd>
				<dd>재활용품 반입차량은 저속운전을 통해 <b>소음을 최소화</b>할 <br>예정이며 청결하게 유지관리 할 것입니다.</dd>
			</dl>
		</div>
	</div>
  </div>
</div>
   
</template>

<script>
export default {
	name: 'RecycleSummaryWin',
    methods: {
        closeClickHandler() {
            this.$emit('close-summary-win');
        }
    }
}
</script>

<style scoped>

</style>
